import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import StickyMobileCTA from "./StickyMobileCTA";
import BackToTop from "./BackToTop";
import { Reveal } from "./Reveal";

/**
 * Consistent page wrapper for single-section detail pages
 * (Who We Serve, Why Us, Gallery). Renders shared chrome + a charcoal hero
 * with eyebrow/title/subtitle and a "Back to Home" pill.
 */
export const SectionPage = ({ eyebrow, title, subtitle, children, hero = "charcoal" }) => {
  const isCharcoal = hero === "charcoal";
  return (
    <div className="App font-sans bg-white text-brand-charcoal antialiased">
      <Header />
      <main>
        <section
          data-testid="section-page-hero"
          className={`pt-24 sm:pt-28 lg:pt-32 pb-10 sm:pb-12 overflow-x-hidden ${
            isCharcoal ? "bg-brand-charcoal grain" : "bg-brand-cream"
          }`}
        >
          <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-10">
            <Reveal>
              <Link
                to="/"
                data-testid="back-to-home-btn"
                className={`inline-flex items-center gap-2 rounded-full px-3.5 py-2 text-[11px] font-bold uppercase tracking-[0.14em] transition-colors ${
                  isCharcoal
                    ? "bg-white/10 hover:bg-white/15 text-white"
                    : "bg-white border border-black/10 text-brand-charcoal hover:bg-brand-charcoal hover:text-white"
                }`}
              >
                <ArrowLeft className="h-3.5 w-3.5" />
                Back to Home
              </Link>
            </Reveal>
            <Reveal delay={1}>
              <p
                className={`mt-6 text-[12px] font-bold uppercase tracking-[0.22em] ${
                  isCharcoal ? "text-brand-gold" : "text-brand-teal"
                }`}
              >
                {eyebrow}
              </p>
            </Reveal>
            <Reveal delay={2}>
              <h1
                className={`mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] ${
                  isCharcoal ? "text-white" : "text-brand-charcoal"
                }`}
              >
                {title}
                <span className="text-brand-gold">.</span>
              </h1>
            </Reveal>
            {subtitle ? (
              <Reveal delay={3}>
                <p
                  className={`mt-4 max-w-2xl text-[15px] lg:text-[17px] leading-relaxed ${
                    isCharcoal ? "text-white/70" : "text-brand-charcoal/70"
                  }`}
                >
                  {subtitle}
                </p>
              </Reveal>
            ) : null}
          </div>
        </section>

        {children}
      </main>
      <Footer />
      <StickyMobileCTA />
      <BackToTop />
    </div>
  );
};

export default SectionPage;
